<template>
  <div class="kura_tm_section">
    <div class="kura_tm_copyright">
      <div class="container">
        <div class="copyright_inner wow fadeInUp" data-wow-duration=".7s">
          <div class="text">
            <p>
              Copyright &copy; {{ new Date().getFullYear() }}. All rights
              reserved.
            </p>
          </div>
          <div class="social">
            <ul>
              <li>
                <a href="#"
                  ><img class="svg" src="img/svg/social/facebook.svg" alt=""
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img class="svg" src="img/svg/social/twitter.svg" alt=""
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img class="svg" src="img/svg/social/instagram.svg" alt=""
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img class="svg" src="img/svg/social/dribbble.svg" alt=""
                /></a>
              </li>
              <li>
                <a href="#"
                  ><img class="svg" src="img/svg/social/tik-tok.svg" alt=""
                /></a>
              </li>
              <!-- If you want to change or add any svg icons you can download here for free www.flaticon.com -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
